import request from '@/utils/request'

export function queryLatestData(devid) {
  return request({
    url: `/realtime/${devid}`,
    method: 'get'
  })
}
